/* rs-az-picker.js — <dialog id="rsaz"> behaviour; see snippets/rs-az-picker.liquid. Deferred, no globals.
   [data-rsaz-open] opens it (data-rsaz-letter="T" lands on T); "#az=T" opens on load; no dialog = no-op.
   Focus return: an opener may name a different return target with data-rsaz-return="<selector>" (the
   hamburger drawer's A–Z row does — the drawer is closed by the time the picker closes, so focusing the
   row would be a no-op and focus would fall to <body>). If the resolved target is not rendered when the
   picker closes, the header's hamburger trigger takes the focus instead (WCAG 2.4.3). */
(function () {
  var d = document.getElementById('rsaz');
  if (!d) return;
  if (!d.showModal) { // pre-15.4 Safari
    d.showModal = function () { d.setAttribute('open', ''); };
    d.close = function () { d.removeAttribute('open'); d.dispatchEvent(new Event('close')); };
  }
  var html = document.documentElement;
  var tabs = [].slice.call(d.querySelectorAll('[data-rsaz-letter]'));
  var live = tabs.filter(function (t) { return !t.hasAttribute('aria-disabled'); });
  var panels = [].slice.call(d.querySelectorAll('.rsaz__panel'));
  var scroller = d.querySelector('.rsaz__panels');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var opener = null, closing = false;

  function remember(v) { try { if (v === undefined) return sessionStorage.getItem('rsaz-letter'); sessionStorage.setItem('rsaz-letter', v); } catch (e) {} }
  function tabFor(L) {
    if (!L) return null;
    L = String(L).toUpperCase();
    for (var i = 0; i < live.length; i++) if (live[i].getAttribute('data-rsaz-letter') === L) return live[i];
    return null;
  }
  function select(t, focus) {
    if (!t) return;
    var id = t.getAttribute('aria-controls');
    tabs.forEach(function (x) {
      var on = x === t;
      x.setAttribute('aria-selected', on ? 'true' : 'false');
      x.tabIndex = on ? 0 : -1;
    });
    panels.forEach(function (p) { p.hidden = p.id !== id; });
    if (scroller) scroller.scrollTop = 0;
    remember(t.getAttribute('data-rsaz-letter'));
    if (focus) t.focus({ preventScroll: true });
  }
  function open(L, from) {
    var t = tabFor(L) || tabFor(remember()) || live[0];
    if (!t) return;
    opener = from || document.activeElement;
    d.classList.remove('rsaz--out');
    closing = false;
    if (!d.open) d.showModal();
    html.classList.add('rsaz-open');
    select(t, true);
  }
  function close() {
    if (!d.open || closing) return;
    if (reduce.matches) { d.close(); return; }
    closing = true;
    d.classList.add('rsaz--out');
    setTimeout(function () { closing = false; d.classList.remove('rsaz--out'); if (d.open) d.close(); }, 200);
  }

  function returnTarget(o) {
    var sel = o && o.getAttribute && o.getAttribute('data-rsaz-return');
    return (sel && document.querySelector(sel)) || o;
  }
  d.addEventListener('close', function () {
    html.classList.remove('rsaz-open');
    var rendered = opener && opener !== document.body && opener.focus && opener.getClientRects().length;
    var t = rendered ? opener : document.querySelector('.site-header .mobile-nav-trigger');
    if (t && t.focus) { try { t.focus(); } catch (e) { /* detached */ } } // scroll to the opener on purpose: it may sit under the hidden header
    opener = null;
  });
  d.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
  d.addEventListener('click', function (e) {
    if (e.target === d) { close(); return; }
    if (e.target.closest('[data-rsaz-close]')) { close(); return; }
    var t = e.target.closest('[data-rsaz-letter]');
    if (t && !t.hasAttribute('aria-disabled')) select(t, true);
  });
  d.addEventListener('keydown', function (e) {
    var t = e.target.closest && e.target.closest('[data-rsaz-letter]');
    if (!t) return;
    var i = live.indexOf(t), n = -1, k = e.key, len = live.length;
    if (k === 'ArrowRight' || k === 'ArrowDown') n = (i + 1) % len;
    else if (k === 'ArrowLeft' || k === 'ArrowUp') n = (i - 1 + len) % len;
    else if (k === 'Home') n = 0;
    else if (k === 'End') n = len - 1;
    if (n < 0) return;
    e.preventDefault();
    select(live[n], true);
  });
  var y0 = null;
  d.addEventListener('touchstart', function (e) { y0 = e.target.closest('[data-rsaz-grab]') ? e.touches[0].clientY : null; }, { passive: true });
  d.addEventListener('touchmove', function (e) { if (y0 !== null && e.touches[0].clientY - y0 > 60) { y0 = null; close(); } }, { passive: true });
  d.addEventListener('touchend', function () { y0 = null; });

  /* An opener inside the hamburger flyout: close the flyout FIRST, or its focus trap pulls focus back
     out of the picker. On internal pages assets/rs-internal-header.js already does this (so here the
     flyout is no longer active and this is a no-op); on the home page (picker rendered there since
     2026-10-30) nothing else does. Same recipe as that file: activeElement must be a real element —
     header.drawer.js only calls removeTrapFocus(activeElement) when it is truthy. */
  function closeFlyoutAround(o) {
    var flyout = o.closest('header-drawer.site-header__mobile-nav');
    if (!flyout || !flyout.classList.contains('is-active') || typeof flyout.close !== 'function') return;
    flyout.activeElement = document.querySelector('.site-header .mobile-nav-trigger') ||
      document.querySelector('[data-rsc-flyout]') || document.body;
    flyout.close(null, true);
  }

  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-rsaz-open]');
    if (!o) return;
    e.preventDefault();
    closeFlyoutAround(o);
    open(o.getAttribute('data-rsaz-letter'), returnTarget(o));
  });
  var m = /^#az=([a-z#])/i.exec(location.hash);
  if (m) open(m[1]);
})();
